<template>
  <svg class="video-control pause" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
    <path d="M1664 192v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45zm-896 0v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45z" fill="#fff"/>
  </svg>
</template>

<script>
export default {
  name: 'PauseIcon',
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// PauseIcon.vue?3487a04e